<template>
  <body v-show="startRender">
    <div class="myPost_wrapper">
      <!-- title -->
      <div class="main_top">
        <h1><img src ="images/basic/icon/back.svg" onclick="history.back()" class="back">채굴권 안내</h1>
      </div>
      <div class="div_padding"></div>
      <div class="guide_wrap">
        <div class="comment">
          <div class="subject">채굴권 획득 방법</div>
          <div class="text">
           <p> 채굴권을 획득하여 채굴에 참여해보세요.</p>
           <p> 채굴권은 다양한 앱내 활동으로 획득하실 수 있어요.</p>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <td>획득</td>
              <td>컨텐츠</td>
              <td>채굴권 안내</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(guide, idx) in guideList" :key="idx">
              <td>
                <div class="plus">+{{ guide.ticketCnt }}</div>
              </td>
              <td>
                <div class="contents">
                  {{ guide.ticketNm }}
                </div> 
              </td>
              <td>
                <div class="desc">
                  {{ guide.ticketDesc }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </body>
</template>

<script>
import { fetchMiningInfo } from '@/api/info'
export default {
  created() {
    fetchMiningInfo()
    .then(({ data }) => {
      
      this.guideList = data.resultList
      this.startRender = true;
    })
  },
  data() {
    return {
      startRender: false,
      guideList: []
    }
  },
}
</script>

<style scoped>
.guide_wrap {
  padding: 0 30px;
}

.comment .subject {
  font-size: 16px;
  font-weight: 900;
  margin-bottom: 10px;
}
.comment .text {
  font-size: 12px;
  color: #6F737A;
  margin-bottom: 20px;
}

table {
  width: 100%;
}

table thead tr {
  text-align: left;
  border-top: 2px solid black;
  border-bottom: 0.8px solid #D8D8D8;
  height: 45px;
  font-size: 12px;
  font-weight: bolder;
}

table thead tr td {
  padding-top: 14px;
}

table tbody tr{
  border-bottom: 0.8px solid #D8D8D8;
  height: 45px;
  font-size: 12px;
}
table tbody tr td {
  padding-top: 14px;
}

table tbody tr td:nth-child(1), table thead tr td:nth-child(1) {
  width: 15%;
}
table tbody tr td:nth-child(2), table thead tr td:nth-child(2) {
  width: 20%;
}

table tbody tr td:nth-child(2) {
  font-weight: bolder;
}

tbody tr .plus {
  color: #FF7100;
}

tbody tr .desc {
  color: #6F737A;
}
</style>